module.exports = __webpack_public_path__ + "static/media/icon_url-link.edd4e2ab.svg";